/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { ReduxStateDashboard } from '@reducers/dashboardNext/toolkit'
import _ from 'lodash'
import React, { useMemo } from 'react'
import useDistanceMeasurement from '../../../hooks/useDistanceMeasurement'
import RoadTile from './components/RoadTile'
import ranks from './components/StepsPathList'

interface Props {
  stepsPath: any
}
function StepsPath(props: Props) {
  const { stepsPath } = props
  const [distanceMeasurement] = useDistanceMeasurement()

  let { valueTotal: steps = 0 } = stepsPath || {}
  // steps = 10000000 // NOCOMMIT

  let currentPoint = useMemo(() => {
    return steps * 0.76 // kms
  }, [steps])

  // currentPoint = 100000000 // NOCOMMIT

  const activeRankIndex = useMemo(() => {
    const index = _.findIndex(ranks, (rank) => {
      let startPoint: number = ranks[index - 1]?.value || 0
      let endPoint = rank.value

      return startPoint <= currentPoint && currentPoint < endPoint
    })

    return index
  }, [currentPoint])

  const translateY = useMemo(() => {
    let multiplier = activeRankIndex - 2
    if (multiplier <= 0) return 0

    const limit = ranks.length - 2 - 2
    if (activeRankIndex > limit) {
      multiplier = limit
    }

    return 55.7 * multiplier
  }, [activeRankIndex])

  return (
    <div
      css={css`
        padding-top: 10px;
        height: 256px;
        overflow: hidden;
        margin-left: -30px;
        padding-left: 30px;
        margin-right: -10px;
        padding-right: 10px;
      `}
    >
      <div style={{ transform: `translateY(-${translateY}px)` }}>
        <div>
          {_.map(ranks, (rank, index) => {
            // let startPoint = 100 * index // + 100 // 100 is offset because of first element
            // let endPoint = startPoint + 100

            let startPoint: number = ranks[index - 1]?.value || 0
            let endPoint = rank.value

            return (
              <RoadTile
                index={index}
                rank={rank}
                startPoint={startPoint}
                endPoint={endPoint}
                currentPoint={currentPoint}
                key={`steps-path-tile-${index}`}
                measurement={distanceMeasurement}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default StepsPath
